export function request() {

    return {
        type: 'LANGUAGES_FIND_REQUEST'
    };
}

export function error(errors) {
    return {
        type: 'LANGUAGES_FIND_ERROR',
        errors
    };
}

export function finish(languages) {
    return {
        type: 'LANGUAGES_FIND_FINISH',
        languages
    };
}